// Frontend mirror of server/aiot/device-types.js. Kept as pure data so
// the UI never has to call the API just to render a label. When a new
// device type ships, add it here AND on the server (the server registry
// is the source of truth for capability/downlink — this file is labels
// only).

export const DEVICE_TYPES = {
  desktop7: { label: 'View 7', short_label: 'View 7' },
  trident175: { label: 'Trident 1.75 OLED', short_label: 'Trident 1.75' },
};

export function friendlyDeviceTypeLabel(slug, fallback = 'Device') {
  return (slug && DEVICE_TYPES[slug]?.label) || fallback;
}

// DEFAULT_DEVICE_OFFLINE.confirm_minutes: past this the server pages the
// keeper that the display stopped reporting.
export const OFFLINE_CONFIRM_MIN = 15;

// When a device was last heard, in the keeper's own clock: the time today,
// else the date and time, with the year once it is not this year's (a
// display retired last autumn is not "Sep 10").
export function lastHeardText(iso, now = Date.now()) {
  const d = new Date(iso);
  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  if (d.toDateString() === new Date(now).toDateString()) return time;
  const sameYear = d.getFullYear() === new Date(now).getFullYear();
  const date = d.toLocaleDateString([], {
    month: 'short',
    day: 'numeric',
    ...(sameYear ? {} : { year: 'numeric' }),
  });
  return `${date}, ${time}`;
}

// Home's Today row for a display that stopped reporting (owner,
// 2026-10-14). The power-loss pushes page for a day, remind once a day for
// a week and then stop, so the tank itself keeps saying so until the
// device reports again or is removed. Calm, and it never says why: no
// power, no internet and a failed unit look the same from here. Removing
// it is the owner's; a keeper the tank is shared with is not told to.
export function quietDeviceRow(device, { now = Date.now(), owner = true } = {}) {
  const seen = device?.last_seen_at ? new Date(device.last_seen_at).getTime() : NaN;
  if (!Number.isFinite(seen) || now - seen < OFFLINE_CONFIRM_MIN * 60_000) return null;
  const name = device.display_name || friendlyDeviceTypeLabel(device.device_type, 'A device');
  return {
    title: `${name} is not reporting`,
    text:
      `Last heard ${lastHeardText(device.last_seen_at, now)}. Check its power and Wi-Fi.` +
      (owner ? ' Retired? Tap to open its page and remove it.' : ''),
  };
}
